'use strict';

var _ = require('underscore'),
  CarouselBaseView = require('./CarouselBaseView'),
  $ = require('jquery'),
  mediator = require('mediatorjs'),
  utilities = require('../../js/utilities'),
  config = require('../../js/config'),

  ImageCarouselView = CarouselBaseView.extend({

    options: {
      slideClass: '.ImageCarousel-slide',
      slidesToShow: 1,
      slidesToScroll: 1,
      pagination: false,
      infinite: false,
      arrows: true,
      autoplay: false,
      draggable: false,
      touchMove: false
    },

    events: {
      beforeChange: 'onSlideChange'
    },

    initialize: function(options) {
      _.bindAll(this, 'preprocessImg');

      if (utilities._isMobileOrTabletDevice()) {
        options.autoplay = false;
        if (ImageCarouselView.__super__.options) {
          ImageCarouselView.__super__.options.autoplay = false;
        }
        if (this.options) {
          this.options.autoplay = false;
        }
      }

      ImageCarouselView.__super__.initialize.call(this, options);
      mediator.on(config.events.ui.resize, _.bind(this.preprocessSlideImgs, this));

      // Initialize Enlarge button
      if (options.$enlarge && options.$enlarge.length) {
        this.$enlarge = options.$enlarge;
        this.populateEnlargeUrl(0, 0);
      }

      this.preprocessSlideImgs();
    },

    onSlideChange: function(ev, slick, prevIndex, nextIndex) {
      this.trigger('change', prevIndex, nextIndex);
      this.populateEnlargeUrl(nextIndex);
    },

    goToSlide: function(index) {
      this.$el.slick('slickGoTo', index);
    },

    // Preprocess all images
    preprocessSlideImgs: function() {
      this.elRatio = this.el.offsetHeight / this.el.offsetWidth;
      this.$('.ImageCarousel-slide-img').each(this.preprocessImg);
    },

    // Need to preprocess images to make sure they are always contained on screen
    preprocessImg: function(i, el) {
      var imgRatio = el.offsetHeight / el.offsetWidth;

      // Images are full width by default, if the image ratio is greater than the element's
      // ratio, it means it would be taller than the container so we need to set it full height
      if (imgRatio > this.elRatio) {
        $(el).addClass('ImageCarousel-slide-img--fullheight');
      } else {
        $(el).removeClass('ImageCarousel-slide-img--fullheight');
      }
    },

    populateEnlargeUrl: function(nextIndex) {
      if (this.$enlarge && this.$enlarge.length) {
        this.$enlarge.attr('href', this.$('.ImageCarousel-slide-img').eq(nextIndex).attr('src'));
      }
    }

  });

module.exports = ImageCarouselView;



// WEBPACK FOOTER //
// ./assets/components/Carousel/ImageCarouselView.js